// @ts-nocheck

import { createAsyncThunk } from "@reduxjs/toolkit";

import { Delete, Get } from "../../utils/apiUtils";

export const HomeExtraReducer = (builder) => {
    builder
        .addCase(getConsts.fulfilled, (state, action) => {
            state.consts = action.payload;
        })
}

export const getConsts = createAsyncThunk(
    'home/getConsts',
    async () => {
        return await Get('/consts', {msgKey: 'home'});
    }
  );
  
export const LogoutUser = createAsyncThunk(
    'logout',
    async () => {
        return await Delete('/auth/logout', {msgKey: 'home'});
    }
);
  